module.exports = __webpack_public_path__ + "static/img/order-mobile-6.68b07a8d.png";